import { Input, InputWithAction } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { EyeOffRegular, EyeRegular } from "@fluentui/react-icons";
import { useId, useState } from "react";
import { UseFormRegisterReturn } from "react-hook-form";
import { twMerge } from "tailwind-merge";

interface InputGroupProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
  register: UseFormRegisterReturn;
}

function InputGroup({
  className,
  required,
  error,
  label,
  register,
  type,
  ...props
}: InputGroupProps) {
  const id = useId();
  const [isEyeOpen, setIsEyeOpen] = useState(false);

  const action = {
    Icon: isEyeOpen ? EyeOffRegular : EyeRegular,
    onClick: () => {
      setIsEyeOpen((prev) => !prev);
    },
  };

  if (type === "password") {
    return (
      <div className={twMerge("flex flex-col gap-1", className)}>
        <Label label={label} required={required} htmlFor={id} />
        <InputWithAction
          type={isEyeOpen ? "text" : "password"}
          action={action}
          id={id}
          {...register}
          {...props}
        />
        {error && <p className="text-red-500">{error}</p>}
      </div>
    );
  }

  return (
    <div className={twMerge("flex flex-col gap-1", className)}>
      <Label label={label} required={required} htmlFor={id} />
      <Input id={id} {...register} {...props} />
      {error && <p className="text-red-500">{error}</p>}
    </div>
  );
}

export default InputGroup;
